import apiV2 from '../api/v2';
import { toDmError } from './dmErrors';

export interface UpdateAlignersParams {
    current?: number;
    total?: number;
}

export interface AlignersUpdateResult {
    current: number | null;
    total: number | null;
}

export async function updateAligners(
    patientId: string,
    params: UpdateAlignersParams
): Promise<AlignersUpdateResult> {
    try {
        const response = await apiV2.patch<{ success: boolean; data: AlignersUpdateResult }>(
            `/patients/${patientId}/dm/aligners`,
            params
        );
        return response.data.data;
    } catch (err) {
        throw toDmError(err);
    }
}
